import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import { darkGray } from "../../../common/helpers/colors";

function MonarchLink({ item, type }) {
  let id;
  let url;
  if (type === "disease") {
    id = item.mondo_id;
    const linkId = `${String(id).padStart(7, "0")}`;
    url = `https://monarchinitiative.org/disease/MONDO:${linkId}`;
  } else {
    id = item.hpo_id;
    let linkId;
    if (id?.startsWith("HP:")) {
      linkId = id;
    } else {
      linkId = `HP:${String(id).padStart(7, "0")}`;
    }
    url = `https://monarchinitiative.org/phenotype/${linkId}`;
  }

  return id ? (
    <a
      href={getVarsoUrl(url)}
      target="_blank"
      style={{ color: darkGray }}
      className="tw-rounded tw-px-1"
      title="View on Monarch"
    >
      Monarch
      <i style={{ color: darkGray }} className="fa fa-external-link tw-pl-1" />
    </a>
  ) : null;
}

MonarchLink.propTypes = {
  type: PropTypes.oneOf(["disease", "phenotype", "gene"]).isRequired,
  item: PropTypes.shape({
    mondo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hpo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

MonarchLink.defaultProps = {
  item: {},
};

export default MonarchLink;
